import { render, staticRenderFns } from "./wjTrainList.vue?vue&type=template&id=5045dfb0&"
import script from "./wjTrainList.vue?vue&type=script&lang=js&"
export * from "./wjTrainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports